import React from "react";
import { Helmet } from "react-helmet";
import { Main } from "../sections/Main/Main";
import { Music } from "../sections/Music/Music";
import { ContactForm } from "../sections/Contact/Contact";
import { VideoShowcase } from "../components/common/VideoShowcase/VideoShowcase";
import { ArtistsShowcase } from "../components/common/ArtistsShowcase/ArtistsShowcase";
import { UniverseShowcase } from "../components/common/UniverseShowcase/UniverseShowcase";
import { Label } from "../sections/Label/Label";
import { MerchTeaser } from "../sections/MerchTeaser/MerchTeaser";

import G1 from "../assets/images/artists/a-1.png";
import G2 from "../assets/images/artists/a-2.png";
import G3 from "../assets/images/artists/a-3.png";
import G4 from "../assets/images/artists/a-4.png";
import G5 from "../assets/images/artists/a-5.png";
// import G6 from '../assets/images/artists/a-6.png';
import G7 from "../assets/images/artists/a-7.png";
import G8 from "../assets/images/artists/a-8.png";
import G9 from "../assets/images/artists/a-9.png";
// import G10 from '../assets/images/artists/a-10.png';
import G11 from "../assets/images/artists/a-11.png";
import G12 from "../assets/images/artists/a-12.png";
import G13 from "../assets/images/artists/a-13.png";
import G14 from "../assets/images/artists/a-14.png";
import G15 from "../assets/images/artists/a-15.png";
import G16 from "../assets/images/artists/a-16.png";
import G17 from "../assets/images/artists/a-17.png";
import G18 from "../assets/images/artists/a-18.png";
import I1 from "../assets/images/universe/1.jpg";
import I2 from "../assets/images/universe/2.jpg";
import I3 from "../assets/images/universe/3.jpeg";
import I4 from "../assets/images/universe/4.jpg";
import I5 from "../assets/images/universe/5.jpg";
import I6 from "../assets/images/universe/6.jpg";

const Home = () => {
  const videos = [
    "https://www.youtube.com/embed/EtAClhq7ThU?si=gzixXwYdLTsYUakL",
    "https://www.youtube.com/embed/6Vc_cbw7Wak?si=z-rGvny6sH351nOG",
    "https://www.youtube.com/embed/b8vANIh3HZg?si=drPj4hvDB-SEG77P",
    "https://www.youtube.com/embed/0EtNLFY77Ho?si=udpYh3HHQC7RPHhO",
    "https://www.youtube.com/embed/jMRCgvI5u4U?si=1qx_K5hoYLq9Ni-E",
    "https://www.youtube.com/embed/2O9726JR1tw?si=BfLRskB1ALfyJ-YB",
    "https://www.youtube.com/embed/xc5h0CVSg2A?si=y3Qf52_uzM9Oc7lv",
    "https://www.youtube.com/embed/dQS3YfbBJK0?si=zGEeQxxFe-ZQkW1R",
    "https://www.youtube.com/embed/l1om1nwB6O4?si=EbKsUO26YCM1vxX-",
    "https://www.youtube.com/embed/l1om1nwB6O4?si=4yqeRYj2vALqDioB"
  ];

  const artists = [
    { name: "Artist 01", image: G1 },
    { name: "Artist 02", image: G2 },
    { name: "Artist 03", image: G3 },
    { name: "Artist 04", image: G4 },
    { name: "Artist 05", image: G5 },
    { name: "Artist 06", image: G7 },
    { name: "Artist 07", image: G8 },
    { name: "Artist 08", image: G9 },
    { name: "Artist 09", image: G11 },
    { name: "Artist 10", image: G12 },
    { name: "Artist 11", image: G13 },
    { name: "Artist 12", image: G14 },
    { name: "Artist 13", image: G15 },
    { name: "Artist 14", image: G16 },
    { name: "Artist 15", image: G17 },
    { name: "Artist 16", image: G18 }
  ];

  const universeImages = [I1, I2, I3, I4, I5, I6];

  const lhangarVideos = [
    "https://www.youtube.com/embed/B3SMoq0pwkM?si=E8zHqLQF4SRAciVM",
    "https://www.youtube.com/embed/Td0u0mJSV8E?si=bH9X83TciWFmRWN8",
    "https://www.youtube.com/embed/rO2SF_reLT0?si=viVEZsLh5Rw8e-s4",
    "https://www.youtube.com/embed/WmptIXY33hM?si=4xETkvkRGwkmrwM1"
  ];

  return (
    <>
      <Helmet>
        <title>Lembawe9 - Moroccan Rap Pioneer</title>
        <meta
          name="description"
          content="Official website of Lembawe9, the influential Moroccan street rap artist. Listen, shop, and connect."
        />
      </Helmet>
      
      <main>
        <Main />

        <VideoShowcase
          sectionNumber="01"
          eyebrow="STREET RAP"
          title="FROM THE STREET."
          accentTitle="TO THE CULTURE."
          description="Street Rap | راب الشوارع is a pioneering Moroccan rap format created by Lembawe9. Built around authenticity, discovery and raw street culture, the platform has helped expose a new generation of artists and connect emerging talent with the wider music industry."
          videos={videos}
          viewAllPath="/راب-الشوارع"
        />

        <VideoShowcase
          sectionNumber="02"
          eyebrow="LHANGAR CYPHER"
          title="SIX ARTISTS."
          accentTitle="ONE STAGE."
          description="LHANGAR brings established names and rising Moroccan rappers together for an exclusive live cypher. Every artist delivers 32 bars across two beats while each edition travels through distinctive locations, connecting music, culture and Morocco's creative identity."
          videos={lhangarVideos}
          viewAllPath="/lhangar"
        />

        <Music />

        <ArtistsShowcase artists={artists} viewAllPath="/artists" />

        <Label />

        <UniverseShowcase images={universeImages} viewAllPath="/universe" />
        
        <MerchTeaser />

        <ContactForm />

      </main>
    </>
  );
};

export default Home;
